import { forwardRef, memo } from 'react'

import type { IZaiSideChatIframeView } from './zai-side-chat-iframe.types'

const Component = forwardRef<HTMLIFrameElement, IZaiSideChatIframeView>(({ iframeDisplay, iframeSrc }, ref) => (
  <iframe
    title="Zai Chat"
    name="zai-side-chat-iframe"
    data-show={iframeDisplay}
    ref={ref}
    src={iframeSrc}
    allow="clipboard-read; clipboard-write"
  />
))

export const ZaiSideChatIframeView = memo(Component)
